<script lang="ts">
    
    import { tweened } from 'svelte/motion';
    import { fade } from 'svelte/transition';
    import { navigate } from "svelte-navigator";

    const markerLeft = tweened(0, {
        duration: 3000
    });

    markerLeft.subscribe(left => {
        if (left === 100) {
            navigate('/menu');
        }
    });

    markerLeft.set(100);

</script>

<div class="view" transition:fade>

    <header>
        <div class="app-zone">
            <!-- svelte-ignore a11y-missing-attribute -->
            <img class="mascot" src="/images/mascot.svg">
            <img class="logo" src="/images/logo.svg" alt="Caminos Rurales de la agricultura">
        </div>
    
        <img src="/images/ayto-realejos.svg" alt="Ayuntamiento de Los Realejos">

        <div class="redirection">
            <img class="start" style="left: {$markerLeft}%;" src="/images/start-marker.svg" alt="">
            <img class="finish" src="/images/finish-marker.svg" alt="">
        </div>
    </header>

    <footer>
        <img class="footer-logos" src="/images/logos-home.png" alt="">
    </footer>

</div>

<style lang="scss">

    @use '../variables';

    .view {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        gap: 1rem;
    }

    header {
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
    }

    .redirection {
        margin-top: 2rem;
        position: relative;
        width: 100%;
        max-width: 80vw;
        height: 5px;
        border-radius: 1000rem;
        background-color: variables.$color-secondary;

        .start {
            position: absolute;
            bottom: 0;
            left: 0;
            transform: translate(-50%, 5px);
            z-index: 2;
        }

        .finish {
            position: absolute;
            left: 100%;
            bottom: 0;
            transform: translate(-30%, 5px);
        }
    }

    .app-zone {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .mascot {
        width: 300px;
        max-width: 70%;
        margin-bottom: 2rem;
    }

    .logo {
        width: 400px;
        max-width: 80%;
    }

    .footer-logos {
        width: 100%;
    }

</style>
